import { addRpu, disconnectSocket } from 'common/modules/zap/actions';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import { SET_IS_SEARCHING_ZAP_RPU } from '../actionTypes';
import { actions } from '../reducer';

export default (values, onSuccess) => (dispatch) => {
    if (!values) return;

    dispatch(actions[SET_IS_SEARCHING_ZAP_RPU](true));

    const newValues = {
        cfeUser: values.cfe_user,
        credentialId: values.credential_id,
        lastPayment: values.last_payment,
        maxPeriods: 1,
        serviceNumber: values.service_number,
    };

    dispatch(addRpu(newValues))
        .then((data) => {
            if (onSuccess) onSuccess(data);
        })
        .catch((error) => {
            dispatch(disconnectSocket());

            showReponseErrorsAsAlert(dispatch, error?.response);
        })
        .finally(() => dispatch(actions[SET_IS_SEARCHING_ZAP_RPU](false)));
};
